import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationError, Event, NavigationCancel, RoutesRecognized } from '@angular/router';
import { LoadingService } from './pages/shared/app-loading/loading.service';
import { RouteService } from './services/router/route.service';
import { PrimeNGConfig } from 'primeng/api';

/**
 * NJIIS Component
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  /**
   * Title of the app
   */
  title = 'njiis';
 
  /**
   * constructor to inject dependency
   * @param router instance of router
   * @param loadingService instance of loadingService
   * @param routeService instance of routeService
   * @param primengConfig instance of primengConfig
   */
  constructor(
    private router: Router,
    private loadingService: LoadingService,
    private routeService: RouteService,
    private primengConfig: PrimeNGConfig
  ) {
    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
        loadingService.displayLoader('');
      }

      if (event instanceof RoutesRecognized) {
        console.log(event);
      }

      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        // Hide loading indicator
        loadingService.hideLoader();
      }

      if (event instanceof NavigationError) {
        // Hide loading indicator
        loadingService.hideLoader();
        // Present error to user
        console.log(event.error);
      }
    });
  }

  /**
   * initialize component
   */
  ngOnInit() {
    this.primengConfig.ripple = true;
  }
}
